import { useWebinarT } from '@/hooks/useWebinarT';
import { Info } from 'lucide-react';
import { Label } from '@/components/ui/label';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useCamLayout } from '@/features/live/camLayoutContext';
import { camLayoutCapacity, isSameCamLayout, toCamLayoutSelection } from '@/lib/camLayouts';
import CamLayoutSelectors from './CamLayoutSelectors';

/**
 * Mise en page caméras dans la roue crantée des régies admin et modérateur : le choix du live
 * (initialisé sur le défaut du workspace) et l'info de capacité.
 */
export default function CamLayoutSettings() {
  const { t } = useWebinarT('common');
  const { preferred, effective, setPreferred, canEdit } = useCamLayout();
  if (!canEdit) return null;

  const applied = toCamLayoutSelection(effective);
  return (
    <div className="flex flex-col gap-3">
      <div className="flex flex-col gap-2 lg:flex-row lg:items-center">
        <div className="flex items-center gap-2 lg:w-44 lg:shrink-0">
          <Tooltip>
            <TooltipTrigger asChild>
              <button type="button" className="text-tertiary" aria-label={t('camLayout.title')}>
                <Info className="size-4" />
              </button>
            </TooltipTrigger>
            <TooltipContent side="top" className="max-w-64">
              {t('camLayout.capacityInfo', { count: camLayoutCapacity(preferred) })}
            </TooltipContent>
          </Tooltip>
          <Label className="text-base">{t('camLayout.title')}</Label>
        </div>
        <CamLayoutSelectors
          value={preferred}
          onChange={setPreferred}
          size="sm"
          className="min-w-0 flex-1 sm:grid-cols-[1.1fr_0.8fr_1.1fr] lg:w-[380px] lg:flex-none"
        />
      </div>
      {!isSameCamLayout(preferred, effective) && (
        <p className="text-xs text-tertiary">
          {t('camLayout.applied', {
            position: t(`camLayout.position_${applied.position}`),
            size: t(`camLayout.size_${applied.size}`),
            format: t(`camLayout.format_${applied.format}`),
          })}
        </p>
      )}
    </div>
  );
}
